<template>
	<div>
		<spinner v-if="subscriptions.loading"/>
		<div v-else class="idi-table subscriptions">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.service') }}</div>
				<div class="idi-cell">{{ $t('labels.general.price_by_unit') }}</div>
				<div class="idi-cell">{{ $t('labels.general.units') }}</div>
				<div class="idi-cell">{{ $t('labels.general.total') }}</div>
				<div class="idi-cell">{{ $t('labels.general.payment') }}</div>
				<div class="idi-cell">{{ $t('labels.general.next_payment') }}</div>
				<div class="idi-cell">{{ $t('labels.general.auto_renew') }}</div>
				<div class="idi-cell">{{ $t('labels.general.status') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row-empty" v-if="!subscriptions.data.length">
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
			<div class="idi-row" v-for="subscription in subscriptions.data" :key="subscription.id">
				<div class="idi-cell">
					<span>{{ subscription.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(serviceNamesTranslated.get(subscription.service_name)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.price_unity }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.units }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.total }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(paymentFrequencyTranslated.get(subscription.frequency_payment)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.next_payment_date.date | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span :class="subscription.auto_renew ? 'true' : 'false'">{{ subscription.auto_renew ? '✓' : 'ꭙ' }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.transaction.state }}</span>
				</div>
				<div class="idi-cell grid-area-operations">
					<router-link
						:to="{ name: 'UserProfileSubscriptionsSubscriptionView', params: { user_uid, subscription_id: subscription.id, subscription_data: subscription } }"
						class="btn btn-round btn-small">{{ $t('labels.general.view') }}</router-link>
				</div>
			</div>
		</div>
		<subscription-form v-if="modalBox.open" @close="onCloseModal" :user_uid="user_uid"/>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
import SubscriptionForm from './SubscriptionForm'
export default {
	components: {
		SubscriptionForm
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			vue: this,
			name: 'subscriptions',
			services: new ApiCollection(),
			subscriptions: new ApiCollection(),
			paymentFrequencyTranslated: new Map([ [ -2, 'labels.general.yearly' ], [ -1, 'labels.general.monthly' ], [ 0, 'labels.general.daily' ] ]),
			serviceNamesTranslated: new Map([ [ 'Rent watches', 'labels.general.rent_watches' ], [ 'Seats', 'labels.general.seats' ] ]),
			modalBox: {
				open: false
			}
		}
	},
	methods: {
		getServicesData () {
			this.services.loading = true
			return this.$api.subscriptions.services.getAll(this)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.services.getAll OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.services.getAll ERROR', error)()
					this.services.error = error
				}).finally(() => {
					this.services.loading = false
				})
		},
		getSubscriptionsData () {
			this.subscriptions.loading = true
			return this.$api.subscriptions.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.getAll OK', response)()
					const data = response.body.map(el => {
						el.price_base_unity = Number.parseFloat(el.price_base_unity).toFixed(2)
						el.tax_unity = Number.parseFloat(el.tax_unity).toFixed(2)
						el.price_unity = Number.parseFloat(el.price_unity).toFixed(2)
						el.tax_percent = Number.parseFloat(el.tax_percent).toFixed(2)
						el.total = Number.parseFloat(el.total).toFixed(2)
						el.transaction = el.transaction || { state: 'Unpaid' }
						return el
					})
					return data
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.getAll ERROR', error)()
					this.subscriptions.error = error
				}).finally(() => {
					this.subscriptions.loading = false
				})
		},
		getSubscriptions () {
			Promise.all([this.getServicesData(), this.getSubscriptionsData()])
				.then(([services, subscriptions]) => {
					const map = new Map()
					this.services.data = services
					this.services.data.forEach(ele => { map.set(ele.id, ele.name) })
					this.subscriptions.data = subscriptions.map(sub => {
						const service_name = map.get(sub.service_id) || ''
						return { ...sub, service_name }
					})
				})
		},
		onOpenModal () {
			this.modalBox.open = true
		},
		onCloseModal (params) {
			this.modalBox.open = false
			if (params && params.reload) this.getSubscriptions()
		}
	},
	created () {
		this.$parent.$on('open-modal-add-subscription', this.onOpenModal)
	},
	beforeDestroy () {
		this.$parent.$off('open-modal-add-subscription', this.onOpenModal)
	},
	mounted () {
		this.getSubscriptions()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/Subscriptions.vue